import React from 'react';
import { useState } from 'react';
import { motion } from 'framer-motion';
import { staggerCards, cardItem, fadeInUp } from '../utils/animations';
import Section from './ui/Section';
import SectionHeading from './ui/SectionHeading';
import Button from './ui/Button';
import Icon from './ui/Icon';
import { CASE_STUDIES } from '../utils/constants';

const CaseStudies: React.FC = () => {
  const [activeCase, setActiveCase] = useState(CASE_STUDIES[0].id);

  return (
    <Section id="cases" bgColor="primary">
      <SectionHeading
        title="Наш опыт в цифрах и результатах"
        subtitle="Реальные проекты, которые принесли клиентам измеримую пользу"
        light
      />

      {/* Case study tabs - Mobile version */}
      <div className="mb-8 block md:hidden">
        <select
          className="w-full rounded-md border border-white/20 bg-white/10 p-3 text-white focus:border-secondary focus:outline-none focus:ring-2 focus:ring-secondary/50"
          value={activeCase}
          onChange={(e) => setActiveCase(e.target.value)}
        >
          {CASE_STUDIES.map((caseStudy) => (
            <option key={caseStudy.id} value={caseStudy.id}>
              {caseStudy.client} - {caseStudy.size}
            </option>
          ))}
        </select>
      </div>

      {/* Case study tabs - Desktop version */}
      <div className="mb-8 hidden border-b border-white/20 md:block">
        <div className="flex flex-wrap w-full">
          {CASE_STUDIES.map((caseStudy, index) => (
            <React.Fragment key={caseStudy.id}>
              <button
                className={`mr-4 border-b-2 pb-4 pt-2 text-lg font-medium transition-colors ${
                  activeCase === caseStudy.id
                    ? 'border-secondary text-secondary'
                    : 'border-transparent text-white/80 hover:text-white'
                }`}
                onClick={() => setActiveCase(caseStudy.id)}
              >
                {caseStudy.client}
              </button>
              {index < CASE_STUDIES.length - 1 && (
                <span className="border-l-2 border-secondary h-full mx-2" />
              )}
            </React.Fragment>
          ))}
        </div>
      </div>

      {/* Case study content */}
      <div className="grid gap-8">
        {CASE_STUDIES.map((caseStudy) => (
          <motion.div
            key={caseStudy.id}
            className={`rounded-lg bg-white/10 p-6 backdrop-blur-sm ${
              activeCase === caseStudy.id ? 'block' : 'hidden'
            }`}
            initial="hidden"
            animate={activeCase === caseStudy.id ? 'visible' : 'hidden'}
            variants={fadeInUp}
          >
            <div className="mb-6">
              <h3 className="mb-2 text-2xl font-bold text-white">
                {caseStudy.client}
              </h3>
              <p className="text-lg text-white/80">{caseStudy.size}</p>
            </div>

            <div className="mb-6">
              <h4 className="mb-2 font-semibold text-secondary">Задача</h4>
              <p className="text-white/90">{caseStudy.challenge}</p>
            </div>

            <div className="mb-6">
              <h4 className="mb-2 font-semibold text-secondary">Решение от IT Joy</h4>
              <p className="text-white/90">{caseStudy.solution}</p>
            </div>

            <div className="mb-6">
              <h4 className="mb-2 font-semibold text-secondary">Результаты</h4>
              <ul className="list-inside list-disc space-y-1 text-white/90">
                {caseStudy.result.map((item) => (
                  <li key={item.substring(0, 15)} className="flex items-start">
                    <span className="mr-2 mt-1 text-secondary">•</span>
                    <span>{item}</span>
                  </li>
                ))}
              </ul>
            </div>

            <Button
              variant="secondary"
              onClick={() => {
                const contactForm = document.getElementById('main-cta');
                contactForm?.scrollIntoView({ behavior: 'smooth' });
              }}
            >
              Хотите такой же результат?
            </Button>
          </motion.div>
        ))}

        {/* Testimonial or image side */}
        {/* <motion.div
          className="relative hidden h-full rounded-lg bg-white/5 p-6 backdrop-blur-sm md:block"
          variants={fadeInUp}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true }}
        >
          <div className="flex h-full flex-col items-center justify-center text-center">
            <div className="mb-6 rounded-full bg-secondary/20 p-4 text-secondary">
              <Icon name="star" size={48} />
            </div>
            <h3 className="mb-4 text-2xl font-bold text-white">
              Более 500 успешных проектов
            </h3>
            <p className="mb-8 text-lg text-white/80">
              За {new Date().getFullYear() - 2005} лет работы мы реализовали сотни проектов
              различной сложности для компаний из разных отраслей.
              Нашим клиентам мы гарантируем индивидуальный подход,
              профессиональную реализацию и поддержку после запуска.
            </p>
            <Button
              variant="secondary"
              onClick={() => {
                const contactForm = document.getElementById('main-cta');
                contactForm?.scrollIntoView({ behavior: 'smooth' });
              }}
            >
              Обсудить ваш проект
            </Button>
          </div>

          
          <div className="absolute -bottom-10 -right-10 h-40 w-40 rounded-full bg-secondary/10 blur-3xl" />
          <div className="absolute -left-10 -top-10 h-40 w-40 rounded-full bg-secondary/10 blur-3xl" />
        </motion.div>*/}
      </div>

      {/* Logos of clients 
      <motion.div
        className="mt-16"
        variants={fadeInUp}
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true }}
      >
         <h3 className="mb-8 text-center text-xl font-semibold text-white">
          Нам доверяют
        </h3>
        <div className="grid grid-cols-2 gap-8 md:grid-cols-3 lg:grid-cols-5">
          {['client1', 'client2', 'client3', 'client4', 'client5'].map((clientId) => (
            <div
              key={clientId}
              className="flex h-20 items-center justify-center rounded-md bg-white/10 px-6 backdrop-blur-sm"
            >
              <div className="h-10 w-36 rounded bg-white/30" />
            </div>
          ))}
        </div> 
      </motion.div>*/}
    </Section>
  );
};

export default CaseStudies;
